var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SdkApi } from '@or-sdk/sdk-api';
import { ROLES } from './constants';
export class Settings {
    constructor(params) {
        const { token, discoveryUrl, sdkUrl } = params;
        this.sdkApi = new SdkApi({
            token,
            discoveryUrl,
            sdkUrl,
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.sdkApi.init();
        });
    }
    accountSettingsRoute({ accountId, key }) {
        if (accountId && key) {
            return `/accounts/${accountId}/account-settings/${key}`;
        }
        else if (accountId) {
            return `/accounts/${accountId}/account-settings`;
        }
        else if (key) {
            return `/account-settings/${key}`;
        }
        return '/account-settings';
    }
    userSettingsRoute({ accountId, userId, key }) {
        if (accountId && userId && key) {
            return `/accounts/${accountId}/users/${userId}/user-settings/${key}`;
        }
        else if (accountId && userId) {
            return `/accounts/${accountId}/users/${userId}/user-settings`;
        }
        else if (userId && key) {
            return `/users/${userId}/user-settings/${key}`;
        }
        else if (userId) {
            return `/users/${userId}/user-settings`;
        }
        else if (key) {
            return `/user-settings/${key}`;
        }
        return '/user-settings';
    }
    mergedSettingsRoute({ accountId, userId, key }) {
        if (accountId && userId && key) {
            return `/accounts/${accountId}/users/${userId}/settings/${key}`;
        }
        else if (accountId && userId) {
            return `/accounts/${accountId}/users/${userId}/settings`;
        }
        else if (userId && key) {
            return `/users/${userId}/settings/${key}`;
        }
        else if (userId) {
            return `/users/${userId}/settings`;
        }
        else if (key) {
            return `/settings/${key}`;
        }
        return '/settings';
    }
    getRoleSettings(role, payload, ...rest) {
        switch (role) {
            case ROLES.SUPER_ADMIN:
            case ROLES.ADMIN:
                return this.getAccountSettings(payload, ...rest);
            case ROLES.USER:
            case ROLES.GUEST:
                return this.getUserSettings(payload, ...rest);
            default:
                return Promise.reject('Role is not valid');
        }
    }
    setRoleSettings(role, payload, ...rest) {
        switch (role) {
            case ROLES.SUPER_ADMIN:
            case ROLES.ADMIN:
                return this.setAccountSettings(payload, ...rest);
            case ROLES.USER:
            case ROLES.GUEST:
                return this.setUserSettings(payload, ...rest);
            default:
                return Promise.reject('Role is not valid');
        }
    }
    getAccountSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId, key }, ...rest) {
            const result = yield this.sdkApi.makeRequest({
                method: 'GET',
                route: this.accountSettingsRoute({
                    accountId,
                    key,
                }),
            });
            return key ? result.value : result;
        });
    }
    getUserSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId, userId, key }, ...rest) {
            const result = yield this.sdkApi.makeRequest({
                method: 'GET',
                route: this.userSettingsRoute({
                    accountId,
                    userId,
                    key,
                }),
            });
            return key ? result.value : result;
        });
    }
    getMergedSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId, userId, key }) {
            const result = yield this.sdkApi.makeRequest({
                method: 'GET',
                route: this.mergedSettingsRoute({
                    accountId,
                    userId,
                    key,
                }),
            });
            return key ? result.value : result;
        });
    }
    setAccountSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId, key, value }, ...rest) {
            const result = yield this.sdkApi.makeRequest({
                method: 'POST',
                route: this.accountSettingsRoute({
                    accountId,
                    key,
                }),
                data: value,
            });
            return key ? result.value : result;
        });
    }
    setUserSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId, userId, key, value }, ...rest) {
            const result = yield this.sdkApi.makeRequest({
                method: 'POST',
                route: this.userSettingsRoute({
                    accountId,
                    userId,
                    key,
                }),
                data: value,
            });
            return key ? result.value : result;
        });
    }
    deleteAccountSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId, key }) {
            return this.sdkApi.makeRequest({
                method: 'DELETE',
                route: this.accountSettingsRoute({
                    accountId,
                    key,
                }),
            });
        });
    }
    deleteUserSettings(_a) {
        return __awaiter(this, arguments, void 0, function* ({ accountId, userId, key }) {
            return this.sdkApi.makeRequest({
                method: 'DELETE',
                route: this.userSettingsRoute({
                    accountId,
                    userId,
                    key,
                }),
            });
        });
    }
}
//# sourceMappingURL=Settings.js.map